import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Result } from 'antd';
import { selectRoles } from '../../store/authSlice';
import { homePathForRoles } from '../../Utils/roleNav';

/** Root ("/") -> send the user to the landing that matches their role. */
const RoleHome = () => {
  const roles = useSelector(selectRoles);
  const target = homePathForRoles(roles);
  if (target === '/no-workspace') {
    return (
      <Result
        status="info"
        title="No workspace assigned"
        subTitle="Your account has no PlatformAdmin, CIO, or CFO workspace yet. Contact a Platform Administrator."
      />
    );
  }
  return <Navigate to={target} replace />;
};

export default RoleHome;
